export default {
	required: 'Answer is required',
	mapFirstPoint: 'Select starting point from the map',
	mapNextPoint: 'Select next passage (NB! Distance that was advanced by same transport)',
	mapFillEnded: 'Map passages are listed below the map. Continue to the next question with Next button',
}
